
const initialState = {
    payoutRegenerateHistory: [],    
    loading: false,
    error: null,
};


const payoutRegenerateHistoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'PAYOUT_REGENERATE_HISTORY_SUCCESS':
            return {
                ...state,
                payoutRegenerateHistory: action.payload,
                loading: false,
                error: null,
            };
        case 'PAYOUT_REGENERATE_HISTORY_ERROR':
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};      


export default payoutRegenerateHistoryReducer;